/* G&G Author Earnings dashboard JS.
   Renders /apps/proxy/api/storefront/authors/earnings into the section
   markup. Mostly DOM patching: hide cards that have no data, fill the rest.
   Auth + "is this an author?" gate already happened on the Liquid side.

   Version: 2026-06-12-thumbs-links-r1. Visible in DevTools console so the
   operator can confirm the latest asset is actually loaded by the theme. */
(function () {
  'use strict';
  // Visible in DevTools so the operator can confirm the latest build is live.
  try { console.log('[aed] author-earnings.js v2026-06-18-r22-breakdown-period'); } catch (e) {}

  // Shopify CDN images support on-the-fly resizing via ?width=. The product
  // thumbnails here render into a 44px box, so a full-res original is wasteful -
  // request a small variant. Non-CDN URLs are left untouched.
  function cdnThumb(url, w) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify.com') > -1 || url.indexOf('/cdn/shop/') > -1) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    return url;
  }

  function fmtMoney(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) {
      return (amount || 0).toFixed(2) + ' ' + (currency || '');
    }
  }
  // BUSINESS dates are rendered in the SHOP's time zone, never the viewer's.
  //
  // A bare toLocaleDateString() formats in whatever zone the browser sits in,
  // so the same sale showed one day to someone in Kyiv, another in the Shopify
  // admin (which is always shop time) and a third to a buyer in California.
  // The zone travels down in the API payload; until the first response lands we
  // fall back to the viewer's, which is the old behaviour and never worse.
  var SHOP_TZ = null;
  function setShopTz(tz) { if (tz) SHOP_TZ = tz; }
  function dateOpts(o) {
    var out = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = o[k];
    if (SHOP_TZ) out.timeZone = SHOP_TZ;
    return out;
  }
  function fmtDate(iso) {
    try { return new Date(iso).toLocaleDateString(undefined, dateOpts({})); } catch (e) { return iso; }
  }
  function el(tag, opts) {
    var n = document.createElement(tag);
    if (opts) {
      if (opts.className) n.className = opts.className;
      if (opts.text != null) n.textContent = String(opts.text);
      if (opts.html != null) n.innerHTML = opts.html;
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { n.setAttribute(k, opts.attrs[k]); });
    }
    return n;
  }

  function makeThumb(imageUrl, title) {
    var thumb = document.createElement('div');
    thumb.className = 'aed-row-thumb';
    if (imageUrl) {
      // Real <img> instead of background-image. If the URL is broken, the
      // browser shows a busted-img icon - way easier to diagnose than a
      // silently empty box. The aed-row-thumb-img class clips to the thumb.
      var img = document.createElement('img');
      img.className = 'aed-row-thumb-img';
      img.src = cdnThumb(imageUrl, 96); // 44px box @2x DPR
      img.alt = title || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 44; img.height = 44;
      img.referrerPolicy = 'no-referrer-when-downgrade';
      thumb.appendChild(img);
    } else {
      var letter = document.createElement('span');
      letter.className = 'aed-row-thumb-letter';
      letter.textContent = ((title || '?').trim().charAt(0) || '?').toUpperCase();
      thumb.appendChild(letter);
    }
    return thumb;
  }

  // Build the thumb + text block. When a handle is present, the thumb and
  // the title text are EACH wrapped in their own <a> so only those two
  // tight click-targets navigate to the product. The row body itself is a
  // plain div - hovering empty space does nothing, no big selection box.
  // Returns body + helpers so the caller can append the title text into the
  // pre-built link wrapper, and sub-line(s) into `.aed-row-left`.
  function makeProductBody(handle, imageUrl, title) {
    var body = document.createElement('div');
    body.className = 'aed-row-body';
    var href = handle ? '/products/' + encodeURIComponent(handle) : null;

    // Thumb (wrap in <a> only if we have a destination)
    var thumb = makeThumb(imageUrl, title);
    if (href) {
      var thumbLink = document.createElement('a');
      thumbLink.className = 'aed-row-thumb-link';
      thumbLink.href = href;
      thumbLink.appendChild(thumb);
      body.appendChild(thumbLink);
    } else {
      body.appendChild(thumb);
    }

    var left = document.createElement('div');
    left.className = 'aed-row-left';
    body.appendChild(left);

    // The caller fills `titleHost` with the product title text (and any
    // status badges). When clickable, titleHost is the <a>; otherwise it's
    // a plain div - either way it gets `.aed-row-title-wrap` for layout.
    var titleHost;
    if (href) {
      titleHost = document.createElement('a');
      titleHost.className = 'aed-row-title-link';
      titleHost.href = href;
    } else {
      titleHost = document.createElement('div');
    }
    left.appendChild(titleHost);

    return { body: body, left: left, titleHost: titleHost };
  }

  function init(root) {
    var inner = root.querySelector('.aed-inner');
    if (!inner) return; // guest / non-author panel, nothing to fetch.
    // Theme editor preview: render the dashboard with sample data so the
    // merchant can style every card, stat, and chart bar without needing
    // a logged-in author. Range buttons re-render the same mock at a
    // different length. NO API call.
    var isPreview = root.dataset.aedPreview === '1';
    if (!isPreview && inner.getAttribute('data-aed-is-author') !== '1') return;

    var els = {
      pending: inner.querySelector('[data-aed-pending]'),
      lifetime: inner.querySelector('[data-aed-lifetime]'),
      paid: inner.querySelector('[data-aed-paid]'),
      awaiting: inner.querySelector('[data-aed-awaiting]'),
      meta: inner.querySelector('[data-aed-meta]'),
      substats: inner.querySelector('[data-aed-substats]'),
      breakdownCard: inner.querySelector('[data-aed-breakdown-card]'),
      donut: inner.querySelector('[data-aed-donut]'),
      donutTotal: inner.querySelector('[data-aed-donut-total]'),
      breakdownLegend: inner.querySelector('[data-aed-breakdown-legend]'),
      jobsCard: inner.querySelector('[data-aed-jobs-card]'),
      jobs: inner.querySelector('[data-aed-jobs]'),
      jobsTotal: inner.querySelector('[data-aed-jobs-total]'),
      reportGran: inner.querySelector('[data-aed-report-gran]'),
      reportPicker: inner.querySelector('[data-aed-report-picker]'),
      reportDownload: inner.querySelector('[data-aed-report-download]'),
      chartCard: inner.querySelector('[data-aed-chart-card]'),
      chart: inner.querySelector('[data-aed-chart]'),
      chartLegend: inner.querySelector('[data-aed-chart-legend]'),
      rangeButtons: inner.querySelectorAll('[data-aed-range]'),
      productsCard: inner.querySelector('[data-aed-products-card]'),
      products: inner.querySelector('[data-aed-products]'),
      salesCard: inner.querySelector('[data-aed-sales-card]'),
      sales: inner.querySelector('[data-aed-sales]'),
      salesTotal: inner.querySelector('[data-aed-sales-total]'),
      payoutsCard: inner.querySelector('[data-aed-payouts-card]'),
      payouts: inner.querySelector('[data-aed-payouts]'),
      empty: inner.querySelector('[data-aed-empty]'),
      payoutBtn: inner.querySelector('[data-aed-payout-btn]'),
      payoutMsg: inner.querySelector('[data-aed-payout-msg]'),
    };

    // The CHART card must be in the layout tree from the start so `.aed-chart`
    // always has measurable dimensions for the SVG. Force it visible on init.
    // Every OTHER collapsible card (products / sales / payouts / breakdown /
    // jobs) stays `hidden` until JS confirms it has data - that's what stops
    // the "title box flashes then collapses" flicker on reload.
    [els.chartCard].forEach(function (c) {
      if (c && c.hasAttribute('hidden')) c.removeAttribute('hidden');
    });

    // NUCLEAR OPTION: inline styles on the wrapper / inner / chart elements
    // so the dashboard renders correctly even if `author-earnings.css` is
    // stale / missing / partly applied in the theme. CSS files can lag behind
    // JS uploads; inline rules from this script always ship together with
    // the version log line above, so they're guaranteed to be consistent.
    root.style.display = 'block';
    root.style.width = '100%';
    root.style.boxSizing = 'border-box';
    inner.style.display = 'block';
    inner.style.width = '100%';
    inner.style.boxSizing = 'border-box';
    if (els.chartCard) {
      els.chartCard.style.display = 'block';
      els.chartCard.style.width = '100%';
      els.chartCard.style.boxSizing = 'border-box';
    }
    if (els.chart) {
      els.chart.style.display = 'block';
      els.chart.style.width = '100%';
      els.chart.style.minHeight = '260px';
      els.chart.style.height = '260px';
      els.chart.style.position = 'relative';
      els.chart.style.boxSizing = 'border-box';
    }

    var state = { currency: 'USD', monthly: [], minPayout: 100, lastBalance: null };

    function renderBalance(b) {
      els.pending.textContent = fmtMoney(b.pendingBalance, b.currency);
      els.lifetime.textContent = fmtMoney(b.totalEarned, b.currency);
      els.paid.textContent = fmtMoney(b.totalPaid, b.currency);
      els.awaiting.textContent = fmtMoney(b.awaitingPayout, b.currency);

      // Period detail on Lifetime / Paid out tiles, shown in a popover via a
      // small "i" trigger (no always-on badge cluttering the tile). Pending +
      // Awaiting are momentary snapshots, so they get no detail.
      setTileDetail(els.lifetime, 'Last 30 days', b.last30Earned, b.prev30Earned, b.currency);
      setTileDetail(els.paid, 'Paid last 30 days', b.last30Paid, b.prev30Paid, b.currency);

      var parts = [];
      parts.push(b.earnedSalesCount + ' earned ' + (b.earnedSalesCount === 1 ? 'sale' : 'sales'));
      if (b.refundedSalesCount > 0) parts.push(b.refundedSalesCount + ' refunded');
      parts.push(b.payoutsCount + ' total ' + (b.payoutsCount === 1 ? 'payout' : 'payouts'));
      els.meta.textContent = parts.join(' · ');

      renderSubstats(b);
      renderBreakdown(b);

      state.lastBalance = b;
      updatePayoutButton(b);
    }

    // Free engagement comes back as { total, gated, freeProducts } (both the
    // new gated-freebie system and the old $0 free-product system). Tolerate a
    // bare number too, in case an older endpoint build is live.
    function freebieStats() {
      var fd = state.freebieDownloads;
      if (fd == null) return { total: 0, gated: 0, freeProducts: 0 };
      if (typeof fd === 'number') return { total: fd, gated: fd, freeProducts: 0 };
      return { total: fd.total || 0, gated: fd.gated || 0, freeProducts: fd.freeProducts || 0 };
    }
    function freebieBreakdownText(fd) {
      var parts = [];
      if (fd.gated > 0) parts.push(fd.gated + ' freebie');
      if (fd.freeProducts > 0) parts.push(fd.freeProducts + ' free product');
      return parts.length ? parts.join(' · ') : 'across your free items';
    }

    // Secondary insight chips below the main stats: custom-service earned,
    // discounts given to buyers, and free downloads. Each chip renders only
    // when it has a non-zero value; the whole row hides when none do.
    function renderSubstats(b) {
      if (!els.substats) return;
      var cur = b.currency || state.currency;
      var chips = [];
      if ((b.jobsEarned || 0) > 0) {
        chips.push({ label: 'Custom service earned', value: fmtMoney(b.jobsEarned, cur),
          sub: (b.jobsCount || 0) + ' ' + ((b.jobsCount === 1) ? 'order' : 'orders') });
      }
      if ((b.totalDiscounts || 0) > 0) {
        chips.push({ label: 'Discounts given', value: fmtMoney(b.totalDiscounts, cur),
          sub: 'passed to buyers' });
      }
      var fd = freebieStats();
      if (fd.total > 0) {
        chips.push({ label: 'Free downloads', value: String(fd.total),
          sub: freebieBreakdownText(fd) });
      }
      els.substats.innerHTML = '';
      if (!chips.length) { els.substats.hidden = true; return; }
      chips.forEach(function (c) {
        var tile = el('div', { className: 'aed-substat' });
        tile.appendChild(el('span', { className: 'aed-substat-label', text: c.label }));
        tile.appendChild(el('span', { className: 'aed-substat-value', text: c.value }));
        if (c.sub) tile.appendChild(el('span', { className: 'aed-substat-sub', text: c.sub }));
        els.substats.appendChild(tile);
      });
      els.substats.hidden = false;
    }

    // Income breakdown donut: Products vs Custom service. A CSS conic-gradient
    // ring + legend. Amounts come from the chart SERIES so the split follows
    // the SAME selected period as the chart + lists (falls back to the global
    // balance split if the series is unavailable). Hidden when there's no income.
    function renderBreakdown(b) {
      if (!els.breakdownCard || !els.donut) return;
      var cur = b.currency || state.currency;
      var series = state.monthly || [];
      var products, jobs, prodCount, jobCount;
      if (series.length) {
        products = series.reduce(function (s, m) { return s + (m.earned || 0); }, 0);
        jobs = series.reduce(function (s, m) { return s + (m.jobs || 0); }, 0);
        prodCount = series.reduce(function (s, m) { return s + (m.sales || 0); }, 0);
        jobCount = state.jobsCount || 0;
      } else {
        products = b.productsEarned != null ? b.productsEarned : (b.totalEarned || 0) - (b.jobsEarned || 0);
        jobs = b.jobsEarned || 0;
        prodCount = b.earnedSalesCount || 0;
        jobCount = b.jobsCount || 0;
      }
      products = Math.max(0, products);
      jobs = Math.max(0, jobs);
      var total = products + jobs;
      if (total <= 0) {
        els.breakdownCard.hidden = true;
        els.breakdownCard.classList.add('is-empty');
        return;
      }
      els.breakdownCard.hidden = false;
      els.breakdownCard.classList.remove('is-empty');

      var pPct = total > 0 ? (products / total) * 100 : 0;
      var COLOR_PRODUCTS = 'var(--aed-primary, #5A3E30)';
      var COLOR_JOBS = 'var(--aed-stat-accent-2, #C9A24B)';
      // Single sweep: products from 0..pPct, custom service the remainder.
      els.donut.style.background = 'conic-gradient('
        + COLOR_PRODUCTS + ' 0 ' + pPct.toFixed(2) + '%, '
        + COLOR_JOBS + ' ' + pPct.toFixed(2) + '% 100%)';
      if (els.donutTotal) els.donutTotal.textContent = fmtMoney(total, cur);

      if (els.breakdownLegend) {
        els.breakdownLegend.innerHTML = '';
        var rows = [
          { name: 'Products', amount: products, color: COLOR_PRODUCTS,
            count: prodCount, unit: 'sale' },
          { name: 'Custom service', amount: jobs, color: COLOR_JOBS,
            count: jobCount, unit: 'order' },
        ];
        rows.forEach(function (r) {
          var pct = total > 0 ? Math.round((r.amount / total) * 100) : 0;
          var item = el('div', { className: 'aed-breakdown-item' });

          var topRow = el('div', { className: 'aed-breakdown-top' });
          var dot = el('span', { className: 'aed-breakdown-dot' });
          dot.style.background = r.color;
          topRow.appendChild(dot);
          topRow.appendChild(el('span', { className: 'aed-breakdown-name', text: r.name }));
          topRow.appendChild(el('span', { className: 'aed-breakdown-amount', text: fmtMoney(r.amount, cur) }));
          item.appendChild(topRow);

          // Proportion bar.
          var track = el('div', { className: 'aed-breakdown-bar' });
          var fill = el('span', { className: 'aed-breakdown-bar-fill' });
          fill.style.width = pct + '%';
          fill.style.background = r.color;
          track.appendChild(fill);
          item.appendChild(track);

          var sub = el('div', { className: 'aed-breakdown-sub' });
          sub.appendChild(el('span', { text: pct + '% of income' }));
          sub.appendChild(el('span', { text: r.count + ' ' + (r.count === 1 ? r.unit : r.unit + 's') }));
          item.appendChild(sub);

          els.breakdownLegend.appendChild(item);
        });

        // Footer metric chips so the right column has presence even with just
        // two sources: average per sale, discounts passed to buyers, and free
        // downloads. Only the ones with data render.
        var footer = el('div', { className: 'aed-breakdown-foot' });
        var foots = [];
        if (prodCount > 0) {
          foots.push({ k: 'Avg / sale', v: fmtMoney(products / prodCount, cur) });
        }
        if ((b.totalDiscounts || 0) > 0) {
          foots.push({ k: 'Discounts given', v: fmtMoney(b.totalDiscounts, cur) });
        }
        var fdFoot = freebieStats();
        if (fdFoot.total > 0) {
          foots.push({ k: 'Free downloads', v: String(fdFoot.total) });
        }
        if (foots.length) {
          foots.forEach(function (f) {
            var chip = el('div', { className: 'aed-breakdown-foot-item' });
            chip.appendChild(el('span', { className: 'aed-breakdown-foot-k', text: f.k }));
            chip.appendChild(el('span', { className: 'aed-breakdown-foot-v', text: f.v }));
            footer.appendChild(chip);
          });
          els.breakdownLegend.appendChild(footer);
        }
      }
    }

    // Show + enable the Request payout button when the pending balance reaches
    // the minimum. If a payout is already pending (awaitingPayout > 0) we show
    // a "pending" note instead. Below the minimum we hint how far to go.
    function updatePayoutButton(b) {
      if (!els.payoutBtn) return;
      var min = state.minPayout || 100;
      var cur = b.currency || state.currency;

      if (b.awaitingPayout > 0) {
        els.payoutBtn.hidden = true;
        if (els.payoutMsg) els.payoutMsg.textContent = 'Payout pending: ' + fmtMoney(b.awaitingPayout, cur);
        return;
      }
      if (b.pendingBalance >= min) {
        els.payoutBtn.hidden = false;
        els.payoutBtn.disabled = false;
        if (els.payoutMsg) els.payoutMsg.textContent = '';
      } else {
        els.payoutBtn.hidden = true;
        if (els.payoutMsg) {
          var togo = min - b.pendingBalance;
          els.payoutMsg.textContent = (b.pendingBalance > 0)
            ? fmtMoney(togo, cur) + ' to go until payout'
            : '';
        }
      }
    }

    function requestPayout() {
      if (!els.payoutBtn) return;
      if (isPreview) { if (els.payoutMsg) els.payoutMsg.textContent = 'Preview mode - disabled.'; return; }
      els.payoutBtn.classList.add('is-loading');
      els.payoutBtn.disabled = true;
      if (els.payoutMsg) els.payoutMsg.textContent = 'Requesting...';
      fetch('/apps/proxy/api/storefront/authors/request-payout', { method: 'POST', credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { setShopTz(j && j.timeZone); return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          els.payoutBtn.classList.remove('is-loading');
          if (!resp.ok) {
            els.payoutBtn.disabled = false;
            if (els.payoutMsg) els.payoutMsg.textContent = (resp.json && resp.json.error) || 'Could not request payout.';
            return;
          }
          els.payoutBtn.hidden = true;
          if (els.payoutMsg) els.payoutMsg.textContent = 'Requested ' + fmtMoney(resp.json.amount, resp.json.currency || state.currency) + ' - we will process it shortly.';
          // Refresh the dashboard so balances reflect the reservation.
          load('30d', false);
        })
        .catch(function (e) {
          els.payoutBtn.classList.remove('is-loading');
          els.payoutBtn.disabled = false;
          if (els.payoutMsg) els.payoutMsg.textContent = 'Could not request payout: ' + e.message;
        });
    }
    if (els.payoutBtn) els.payoutBtn.addEventListener('click', requestPayout);

    /**
     * Period detail for a stat tile. Instead of an always-on badge under the
     * number (which made the tiles uneven + cluttered on phones), we attach a
     * small "i" trigger; hovering it (desktop) or tapping it (mobile) reveals a
     * popover with the period figure + delta. Skips entirely when no signal.
     */
    function setTileDetail(valueEl, title, currentPeriod, prevPeriod, currency) {
      if (!valueEl) return;
      var tile = valueEl.closest('.aed-stat');
      if (!tile) return;
      // Clear any previous detail UI so re-renders stay clean.
      var oldInfo = tile.querySelector('.aed-stat-info');
      var oldPop = tile.querySelector('.aed-stat-pop');
      if (oldInfo) oldInfo.parentNode.removeChild(oldInfo);
      if (oldPop) oldPop.parentNode.removeChild(oldPop);
      tile.classList.remove('aed-stat--detail', 'is-open');
      if (!currentPeriod && !prevPeriod) return; // nothing worth showing

      var diff = (currentPeriod || 0) - (prevPeriod || 0);
      var dir = diff > 0 ? 'up' : diff < 0 ? 'down' : 'flat';
      var arrow = dir === 'up' ? '↑' : dir === 'down' ? '↓' : '·';
      var amountTxt = fmtMoney(currentPeriod || 0, currency);
      var deltaTxt = (prevPeriod === 0)
        ? arrow + ' new this period'
        : arrow + ' ' + ((diff > 0 ? '+' : '') + Math.round((diff / prevPeriod) * 100)) + '% vs previous';

      tile.classList.add('aed-stat--detail');
      var info = el('button', { className: 'aed-stat-info', attrs: { type: 'button', 'aria-label': title + ' detail' } });
      info.appendChild(svgEl('<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>'));
      var pop = el('div', { className: 'aed-stat-pop' });
      pop.appendChild(el('span', { className: 'aed-stat-pop-title', text: title }));
      pop.appendChild(el('span', { className: 'aed-stat-pop-value', text: amountTxt }));
      pop.appendChild(el('span', { className: 'aed-stat-pop-delta aed-stat-pop-delta--' + dir, text: deltaTxt }));
      tile.appendChild(info);
      tile.appendChild(pop);

      info.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !tile.classList.contains('is-open');
        if (tile.parentNode) tile.parentNode.querySelectorAll('.aed-stat.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        tile.classList.toggle('is-open', willOpen);
      });
    }

    var PAGE_SIZE = 10;

    /**
     * Generic pager: takes the full item list + a row-render function and
     * wires up a numbered pager under the list. Stores the current page on
     * the card element so range-button re-renders restart at page 1, but
     * within a single dataset prev/next stay sticky.
     *
     * Layout: < 1 2 3 ... 8 >
     * Only renders pager if items.length > PAGE_SIZE.
     */
    function paginate(card, listEl, items, renderSlice) {
      var totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
      var page = parseInt(card.dataset.page || '1', 10);
      if (page < 1) page = 1;
      if (page > totalPages) page = totalPages;
      card.dataset.page = String(page);

      // Render the current slice into the list.
      var start = (page - 1) * PAGE_SIZE;
      listEl.innerHTML = '';
      renderSlice(items.slice(start, start + PAGE_SIZE));

      // Pager element: drop the previous one (if any) and rebuild. Cheap +
      // avoids stale state when item count changes.
      var existing = card.querySelector('.aed-pager');
      if (existing) existing.parentNode.removeChild(existing);
      if (totalPages <= 1) return;

      var pager = el('div', { className: 'aed-pager' });

      var pageInfo = el('span', { className: 'aed-pager-info',
        text: 'Showing ' + (start + 1) + '–' + Math.min(start + PAGE_SIZE, items.length) + ' of ' + items.length });
      pager.appendChild(pageInfo);

      var nav = el('div', { className: 'aed-pager-nav' });

      function mkBtn(label, targetPage, opts) {
        opts = opts || {};
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'aed-pager-btn' + (opts.active ? ' is-active' : '');
        b.textContent = label;
        if (opts.disabled) { b.disabled = true; }
        else if (targetPage != null) {
          b.addEventListener('click', function () {
            card.dataset.page = String(targetPage);
            paginate(card, listEl, items, renderSlice);
          });
        }
        return b;
      }

      nav.appendChild(mkBtn('‹', page - 1, { disabled: page === 1 }));

      // Compact page numbers: first, last, current ± 1, ellipses.
      var pages = [];
      for (var i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
          pages.push(i);
        } else if (pages[pages.length - 1] !== '...') {
          pages.push('...');
        }
      }
      pages.forEach(function (p) {
        if (p === '...') {
          var dots = el('span', { className: 'aed-pager-ellipsis', text: '…' });
          nav.appendChild(dots);
        } else {
          nav.appendChild(mkBtn(String(p), p, { active: p === page }));
        }
      });
      nav.appendChild(mkBtn('›', page + 1, { disabled: page === totalPages }));

      pager.appendChild(nav);
      card.appendChild(pager);
    }

    // Setting display directly via JS so cards collapse even when the
    // theme's CSS is stale and doesn't have the `.aed-card.is-empty` rule.
    // The class still gets toggled for future CSS-only consumers.
    function setCardEmpty(card, isEmpty) {
      if (!card) return;
      card.classList.toggle('is-empty', isEmpty);
      if (isEmpty) {
        card.style.display = 'none';
      } else {
        // Reveal a card that started life `hidden` (anti-flicker default).
        card.removeAttribute('hidden');
        card.style.display = '';
      }
    }

    // Free products (gross 0) are acquired via $0 checkout, so each one still
    // produces a Sale row - `unitsSold` is therefore the download count. We
    // surface that instead of a meaningless "$0 earned".
    function isFreeProduct(p) { return (p.totalGross || 0) === 0; }
    function isFreeSale(s) { return (s.grossAmount || 0) === 0; }
    // Total free acquisitions of a product across BOTH systems: $0-checkout
    // units (unitsSold) + gated newsletter freebie downloads (freebieDownloads).
    function productDownloads(p) { return (p.unitsSold || 0) + (p.freebieDownloads || 0); }

    // --- Shared control widgets (pills + custom sort dropdown), matching the
    //     author-works / My-products visual language. ---
    function svgEl(markup) { var d = document.createElement('div'); d.innerHTML = markup; return d.firstChild; }

    function buildPills(host, options, getActive, onPick) {
      options.forEach(function (o) {
        var b = el('button', { className: 'aed-pill' + (getActive() === o[0] ? ' is-active' : ''), text: o[1], attrs: { type: 'button', role: 'tab', 'data-val': o[0] } });
        b.addEventListener('click', function () {
          host.querySelectorAll('.aed-pill').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          onPick(o[0]);
        });
        host.appendChild(b);
      });
    }

    function buildSortDropdown(sorts, getSort, onPick) {
      var dd = el('div', { className: 'aed-sort' });
      var trigger = el('button', { className: 'aed-sort-trigger', attrs: { type: 'button', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' } });
      trigger.appendChild(svgEl('<svg class="aed-sort-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>'));
      var cur = sorts.filter(function (o) { return o[0] === getSort(); })[0] || sorts[0];
      var valSpan = el('span', { className: 'aed-sort-value', text: cur[1] });
      trigger.appendChild(valSpan);
      trigger.appendChild(svgEl('<svg class="aed-sort-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'));
      var menu = el('div', { className: 'aed-sort-menu', attrs: { role: 'listbox' } });
      sorts.forEach(function (o) {
        var opt = el('button', { className: 'aed-sort-option' + (o[0] === getSort() ? ' active' : ''), text: o[1], attrs: { type: 'button', role: 'option', 'data-value': o[0] } });
        opt.addEventListener('click', function () {
          valSpan.textContent = o[1];
          menu.querySelectorAll('.aed-sort-option').forEach(function (x) { x.classList.toggle('active', x === opt); });
          dd.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false');
          onPick(o[0]);
        });
        menu.appendChild(opt);
      });
      trigger.addEventListener('click', function (e) { e.stopPropagation(); var open = dd.classList.toggle('open'); trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) { dd.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); } });
      dd.appendChild(trigger); dd.appendChild(menu);
      return dd;
    }

    // Insert a controls bar right after a card's title / head.
    function insertControlsBar(card, bar) {
      var head = card.querySelector('.aed-card-head') || card.querySelector('.aed-card-title');
      if (head && head.parentNode === card) card.insertBefore(bar, head.nextSibling);
      else card.insertBefore(bar, card.firstChild);
    }

    var prodState = { items: [], currency: 'USD', sort: 'earned', filter: 'all', built: false };

    function buildProductControls() {
      if (prodState.built) return;
      var bar = el('div', { className: 'aed-controls' });
      var pills = el('div', { className: 'aed-pills', attrs: { role: 'tablist', 'aria-label': 'Filter products' } });
      buildPills(pills, [['all', 'All'], ['paid', 'Paid'], ['free', 'Free']], function () { return prodState.filter; }, function (v) { prodState.filter = v; els.productsCard.dataset.page = '1'; renderProductsList(); });
      bar.appendChild(pills);
      bar.appendChild(buildSortDropdown([['earned', 'Top earning'], ['sales', 'Most sales'], ['downloads', 'Most downloads'], ['title', 'A–Z']], function () { return prodState.sort; }, function (v) { prodState.sort = v; els.productsCard.dataset.page = '1'; renderProductsList(); }));
      insertControlsBar(els.productsCard, bar);
      prodState.built = true;
    }

    function renderProducts(items, currency) {
      prodState.items = items || [];
      prodState.currency = currency;
      if (!prodState.items.length) {
        els.products.innerHTML = '';
        setCardEmpty(els.productsCard, true);
        var stalePager = els.productsCard.querySelector('.aed-pager');
        if (stalePager) stalePager.remove();
        return;
      }
      setCardEmpty(els.productsCard, false);
      buildProductControls();
      renderProductsList();
    }

    function renderProductsList() {
      var currency = prodState.currency;
      var items = prodState.items.slice();
      if (prodState.filter === 'paid') items = items.filter(function (p) { return !isFreeProduct(p); });
      else if (prodState.filter === 'free') items = items.filter(isFreeProduct);

      items.sort(function (a, b) {
        switch (prodState.sort) {
          case 'sales': return (b.salesCount || 0) - (a.salesCount || 0);
          case 'downloads': return productDownloads(b) - productDownloads(a);
          case 'title': return String(a.productTitle || '').localeCompare(String(b.productTitle || ''));
          default: return (b.totalAuthorEarning || 0) - (a.totalAuthorEarning || 0);
        }
      });

      var stale = els.productsCard.querySelector('.aed-pager');
      if (stale) stale.remove();

      if (!items.length) {
        els.products.innerHTML = '';
        els.products.appendChild(el('div', { className: 'aed-row aed-row--empty', text: 'No ' + prodState.filter + ' products yet.' }));
        return;
      }

      paginate(els.productsCard, els.products, items, function (slice) {
        slice.forEach(function (p) {
          var free = isFreeProduct(p);
          var row = el('div', { className: 'aed-row' });
          var built = makeProductBody(p.productHandle, p.productImageUrl, p.productTitle);
          built.titleHost.appendChild(el('span', { className: 'aed-row-title', text: p.productTitle }));
          if (free) {
            var fb = el('span', { className: 'aed-badge aed-badge--free', text: 'Free' });
            fb.style.marginLeft = '6px';
            built.titleHost.appendChild(fb);
          }
          var dls = productDownloads(p);
          built.left.appendChild(el('span', {
            className: 'aed-row-sub',
            text: free
              ? (dls + ' ' + (dls === 1 ? 'download' : 'downloads')
                 + ((p.freebieDownloads || 0) > 0 && (p.unitsSold || 0) > 0
                    ? ' (' + p.freebieDownloads + ' freebie · ' + p.unitsSold + ' free product)' : ''))
              : (p.salesCount + ' ' + (p.salesCount === 1 ? 'sale' : 'sales')
                 + ' · ' + p.unitsSold + ' ' + (p.unitsSold === 1 ? 'unit' : 'units')
                 + ' · gross ' + fmtMoney(p.totalGross, p.currency || currency)),
          }));
          var right = el('div', { className: 'aed-row-right' });
          if (free) {
            right.appendChild(el('span', { className: 'aed-row-amount aed-row-amount--downloads', text: String(dls) }));
            right.appendChild(el('span', { className: 'aed-row-sub', text: (dls === 1 ? 'download' : 'downloads') }));
          } else {
            right.appendChild(el('span', { className: 'aed-row-amount', text: fmtMoney(p.totalAuthorEarning, p.currency || currency) }));
          }
          row.appendChild(built.body);
          row.appendChild(right);
          els.products.appendChild(row);
        });
      });
    }

    var salesState = { items: [], total: 0, currency: 'USD', sort: 'newest', filter: 'all', built: false };

    function buildSalesControls() {
      if (salesState.built) return;
      var bar = el('div', { className: 'aed-controls' });
      var pills = el('div', { className: 'aed-pills', attrs: { role: 'tablist', 'aria-label': 'Filter sales' } });
      buildPills(pills, [['all', 'All'], ['paid', 'Paid'], ['free', 'Free']], function () { return salesState.filter; }, function (v) { salesState.filter = v; els.salesCard.dataset.page = '1'; renderSalesList(); });
      bar.appendChild(pills);
      bar.appendChild(buildSortDropdown([['newest', 'Newest'], ['oldest', 'Oldest'], ['top', 'Highest earning']], function () { return salesState.sort; }, function (v) { salesState.sort = v; els.salesCard.dataset.page = '1'; renderSalesList(); }));
      insertControlsBar(els.salesCard, bar);
      salesState.built = true;
    }

    function renderSales(items, total, currency) {
      salesState.items = items || [];
      salesState.total = total || 0;
      salesState.currency = currency;
      if (!salesState.items.length) {
        els.sales.innerHTML = '';
        setCardEmpty(els.salesCard, true);
        var stalePager = els.salesCard.querySelector('.aed-pager');
        if (stalePager) stalePager.remove();
        return;
      }
      setCardEmpty(els.salesCard, false);
      buildSalesControls();
      renderSalesList();
    }

    function salesTs(s) { return s.createdAt ? new Date(s.createdAt).getTime() : 0; }

    function renderSalesList() {
      var currency = salesState.currency;
      var items = salesState.items.slice();
      if (salesState.filter === 'paid') items = items.filter(function (s) { return !isFreeSale(s); });
      else if (salesState.filter === 'free') items = items.filter(isFreeSale);

      items.sort(function (a, b) {
        switch (salesState.sort) {
          case 'oldest': return salesTs(a) - salesTs(b);
          case 'top': return (b.authorEarning || 0) - (a.authorEarning || 0);
          default: return salesTs(b) - salesTs(a); // newest
        }
      });

      if (els.salesTotal) els.salesTotal.textContent = salesState.total + ' total';

      var stale = els.salesCard.querySelector('.aed-pager');
      if (stale) stale.remove();

      if (!items.length) {
        els.sales.innerHTML = '';
        els.sales.appendChild(el('div', { className: 'aed-row aed-row--empty', text: 'No ' + salesState.filter + ' sales.' }));
        return;
      }

      paginate(els.salesCard, els.sales, items, function (slice) {
        slice.forEach(function (s) {
          var free = isFreeSale(s);
          var row = el('div', { className: 'aed-row' });
          var built = makeProductBody(s.productHandle, s.productImageUrl, s.productTitle);
          built.titleHost.appendChild(el('span', { className: 'aed-row-title', text: s.productTitle }));
          if (free) { var fb = el('span', { className: 'aed-badge aed-badge--free', text: 'Free' }); fb.style.marginLeft = '6px'; built.titleHost.appendChild(fb); }
          if (s.status === 'refunded') {
            var b = el('span', { className: 'aed-badge aed-badge--refunded', text: 'refunded' });
            b.style.marginLeft = '6px';
            built.titleHost.appendChild(b);
          }
          built.left.appendChild(el('span', {
            className: 'aed-row-sub',
            text: s.shopifyOrderName + ' · ' + fmtDate(s.createdAt) + ' · qty ' + s.quantity + ' · share ' + s.revenueSharePct + '%',
          }));
          // Discount transparency: show what the buyer's discount took off, so
          // the earning (a share of the NET) is never a mystery.
          if (s.discountAmount != null && s.discountAmount > 0) {
            built.left.appendChild(el('span', {
              className: 'aed-row-sub',
              text: fmtMoney(s.originalAmount != null ? s.originalAmount : s.grossAmount, s.currency || currency)
                + ' − ' + fmtMoney(s.discountAmount, s.currency || currency) + ' discount = '
                + fmtMoney(s.grossAmount, s.currency || currency) + ' net',
            }));
          }
          var right = el('div', { className: 'aed-row-right' });
          if (free) {
            right.appendChild(el('span', { className: 'aed-row-amount aed-row-amount--downloads', text: 'Free' }));
          } else {
            var amt = el('span', { className: 'aed-row-amount' + (s.status === 'refunded' ? ' is-refunded' : ''), text: fmtMoney(s.authorEarning, s.currency || currency) });
            right.appendChild(amt);
            right.appendChild(el('span', { className: 'aed-row-sub', text: 'of ' + fmtMoney(s.grossAmount, s.currency || currency) }));
          }
          row.appendChild(built.body);
          row.appendChild(right);
          els.sales.appendChild(row);
        });
      });
    }

    /**
     * Catmull-Rom -> cubic Bezier smoothing. Produces a soft curve through
     * every data point without overshooting on flat spots. tension = 0.5.
     */
    function smoothPath(points) {
      if (!points.length) return '';
      if (points.length === 1) return 'M ' + points[0].x + ',' + points[0].y;
      var d = 'M ' + points[0].x + ',' + points[0].y;
      for (var i = 0; i < points.length - 1; i++) {
        var p0 = points[Math.max(0, i - 1)];
        var p1 = points[i];
        var p2 = points[i + 1];
        var p3 = points[Math.min(points.length - 1, i + 2)];
        var cp1x = p1.x + (p2.x - p0.x) / 6;
        var cp1y = p1.y + (p2.y - p0.y) / 6;
        var cp2x = p2.x - (p3.x - p1.x) / 6;
        var cp2y = p2.y - (p3.y - p1.y) / 6;
        d += ' C ' + cp1x + ',' + cp1y + ' ' + cp2x + ',' + cp2y + ' ' + p2.x + ',' + p2.y;
      }
      return d;
    }

    // Stash the latest series + currency so the ResizeObserver can re-call
    // drawChart on container resize. Without this, themes that shift layout
    // after initial render (font swap, sticky-header animation, theme JS
    // mutating page-width) would leave the SVG at the OLD width.
    var chartState = { series: null, currency: 'USD' };
    var chartResizeObserver = null;
    var pendingDrawRaf = 0;

    function renderChart(series, currency) {
      chartState.series = series;
      chartState.currency = currency;

      if (!series || !series.length) {
        setCardEmpty(els.chartCard, true);
        els.chart.innerHTML = '';
        return;
      }

      // No more `hidden` attribute dance - the card is in the layout tree
      // from the start so `.aed-chart` always has measurable dimensions.
      setCardEmpty(els.chartCard, false);

      // Install ResizeObserver ONCE. From then on, container size changes
      // trigger drawChart() with the current stored series. The first draw
      // also goes through here on next frame so it sees a stable layout.
      if (!chartResizeObserver && typeof ResizeObserver !== 'undefined') {
        chartResizeObserver = new ResizeObserver(function () {
          // Coalesce bursts of resize events into a single rAF-tick redraw.
          if (pendingDrawRaf) cancelAnimationFrame(pendingDrawRaf);
          pendingDrawRaf = requestAnimationFrame(function () {
            pendingDrawRaf = 0;
            drawChart();
          });
        });
        chartResizeObserver.observe(els.chart);
      }

      // First draw: defer through 2x rAF so layout has fully settled after
      // unhiding the card. Single rAF wasn't enough on some themes that
      // adjust container widths inside their own rAF callbacks.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawChart(); });
      });
    }

    function drawChart() {
      var series = chartState.series;
      var currency = chartState.currency;
      if (!series || !series.length) return;

      var alreadyRendered = els.chartCard.getAttribute('data-rendered') === '1';
      els.chart.innerHTML = '';
      tooltip = null;

      // Total income per bucket = product earnings + custom-service (jobs).
      // The main line tracks the total; a second line tracks custom service
      // when there's any, so the gap between them reads as product income.
      function ptTotal(m) { return (m.earned || 0) + (m.jobs || 0); }
      var hasJobs = series.some(function (m) { return (m.jobs || 0) > 0; });
      var maxVal = Math.max.apply(null, series.map(ptTotal));
      var hasData = maxVal > 0;
      if (!hasData) maxVal = 1; // avoid div by zero - keeps grid visible

      // Round the Y-axis max to a nice number so labels read clean.
      function niceMax(v) {
        if (v <= 0) return 1;
        var pow = Math.pow(10, Math.floor(Math.log10(v)));
        var n = v / pow;
        var nice = n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10;
        return nice * pow;
      }
      maxVal = niceMax(maxVal);

      // Measure the chart width. PRIMARY source: `.aed-chart` div itself.
      // If that returns zero (some Shopify themes leave it collapsed for
      // reasons CSS-side can't always override), FALL BACK to measuring
      // parent containers and subtracting known padding. This is the most
      // robust way to get a real-pixel chart width regardless of how the
      // theme positions / sizes / hides the inner div.
      var containerRect = els.chart.getBoundingClientRect();
      var W = Math.round(containerRect.width);
      var H = Math.round(containerRect.height) || 260;
      var src = 'chart';
      if (!W || W < 320) {
        // Try card content area = card width - chart card horizontal padding.
        var cardRect = els.chartCard.getBoundingClientRect();
        var cardW = Math.round(cardRect.width);
        if (cardW >= 320) { W = cardW - 32; src = 'card'; } // 16px each side
      }
      if (!W || W < 320) {
        // Try inner content area = inner width - inner padding - card padding.
        var innerRect = inner.getBoundingClientRect();
        var innerW = Math.round(innerRect.width);
        if (innerW >= 320) {
          var cs = getComputedStyle(inner);
          var ipL = parseFloat(cs.paddingLeft) || 0;
          var ipR = parseFloat(cs.paddingRight) || 0;
          W = innerW - ipL - ipR - 32; // 32 = chart card padding (16 each side)
          src = 'inner';
        }
      }
      if (!W || W < 320) {
        // Final fallback: wrapper width.
        var wrapRect = root.getBoundingClientRect();
        var wrapW = Math.round(wrapRect.width);
        if (wrapW >= 320) { W = wrapW - 80; src = 'wrapper'; } // ballpark for padding
      }
      if (!W || W < 320) W = 800; // give up - use the old fallback
      if (H < 200) H = 260;
      // Narrow phones: trim the left gutter (Y-labels) so the line gets more
      // width. Desktop keeps the roomier gutter.
      var padL = W < 420 ? 24 : 30, padR = 6, padT = 20, padB = 32;
      var chartW = W - padL - padR;
      var chartH = H - padT - padB;
      var n = series.length;
      var todayKey = (function () {
        var t = new Date();
        return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
      })();
      var nowMonthKey = (function () {
        var t = new Date();
        return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-01';
      })();

      var svgNS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      // NO svg.setAttribute('width' / 'height') - those bake in pixel sizes
      // that fight CSS `width: 100%; height: 100%`. Letting CSS drive the
      // displayed size + viewBox drive the internal coord system means the
      // SVG cleanly fills whatever container is at hand, even after resize.

      // Gradient for area fill - accent at top fading to transparent at bottom.
      var defs = document.createElementNS(svgNS, 'defs');
      var grad = document.createElementNS(svgNS, 'linearGradient');
      grad.setAttribute('id', 'aed-area-grad-' + Date.now());
      grad.setAttribute('x1', '0'); grad.setAttribute('y1', '0');
      grad.setAttribute('x2', '0'); grad.setAttribute('y2', '1');
      var stop1 = document.createElementNS(svgNS, 'stop');
      stop1.setAttribute('offset', '0%');
      stop1.setAttribute('stop-color', 'var(--aed-chart-bar, var(--aed-primary, #5A3E30))');
      stop1.setAttribute('stop-opacity', '0.25');
      var stop2 = document.createElementNS(svgNS, 'stop');
      stop2.setAttribute('offset', '100%');
      stop2.setAttribute('stop-color', 'var(--aed-chart-bar, var(--aed-primary, #5A3E30))');
      stop2.setAttribute('stop-opacity', '0');
      grad.appendChild(stop1); grad.appendChild(stop2);
      defs.appendChild(grad);
      svg.appendChild(defs);
      var gradId = grad.getAttribute('id');

      // 4 horizontal grid lines + Y-axis labels
      var ticks = 4;
      for (var i = 0; i <= ticks; i++) {
        var ratio = i / ticks;
        var y = padT + chartH - chartH * ratio;
        var line = document.createElementNS(svgNS, 'line');
        line.setAttribute('class', 'aed-chart-grid-line');
        line.setAttribute('x1', padL); line.setAttribute('x2', W - padR);
        line.setAttribute('y1', y); line.setAttribute('y2', y);
        if (i === 0) line.setAttribute('data-baseline', '1');
        svg.appendChild(line);
        var lbl = document.createElementNS(svgNS, 'text');
        lbl.setAttribute('class', 'aed-chart-grid-label');
        lbl.setAttribute('x', padL - 8); lbl.setAttribute('y', y + 3);
        lbl.setAttribute('text-anchor', 'end');
        var labelValue = maxVal * ratio;
        lbl.textContent = labelValue >= 1000
          ? (labelValue / 1000).toFixed(labelValue >= 10000 ? 0 : 1) + 'k'
          : Math.round(labelValue).toString();
        svg.appendChild(lbl);
      }

      // Compute point coordinates. Main line tracks TOTAL income per bucket.
      var slot = chartW / Math.max(1, n - 1);
      var points = series.map(function (m, i) {
        var x = n === 1 ? padL + chartW / 2 : padL + slot * i;
        var ratio = ptTotal(m) / maxVal;
        var y = padT + chartH - chartH * ratio;
        return { x: x, y: y, m: m };
      });
      // Custom-service line points (only used when hasJobs).
      var jobPoints = series.map(function (m, i) {
        var x = n === 1 ? padL + chartW / 2 : padL + slot * i;
        var ratio = (m.jobs || 0) / maxVal;
        var y = padT + chartH - chartH * ratio;
        return { x: x, y: y, m: m };
      });

      // Area fill (closed path back to baseline)
      var areaD = smoothPath(points)
        + ' L ' + points[points.length - 1].x + ',' + (padT + chartH)
        + ' L ' + points[0].x + ',' + (padT + chartH)
        + ' Z';
      var area = document.createElementNS(svgNS, 'path');
      area.setAttribute('class', 'aed-chart-area');
      area.setAttribute('d', areaD);
      area.setAttribute('fill', 'url(#' + gradId + ')');
      svg.appendChild(area);

      // Line (animated draw). pathLength=1 lets the CSS stroke-dasharray:1 +
      // dashoffset:1 trick work regardless of the path's real length.
      var lineD = smoothPath(points);
      var line2 = document.createElementNS(svgNS, 'path');
      line2.setAttribute('class', 'aed-chart-line');
      line2.setAttribute('d', lineD);
      line2.setAttribute('fill', 'none');
      line2.setAttribute('pathLength', '1');
      svg.appendChild(line2);

      // Second line: custom-service (Jobs) contribution. Gold, dashed, no area
      // fill - sits under the total line so the gap = product income. Only when
      // the author actually has custom-service income in this range.
      if (hasJobs) {
        var jobLine = document.createElementNS(svgNS, 'path');
        jobLine.setAttribute('class', 'aed-chart-line aed-chart-line--jobs');
        jobLine.setAttribute('d', smoothPath(jobPoints));
        jobLine.setAttribute('fill', 'none');
        jobLine.setAttribute('pathLength', '1');
        svg.appendChild(jobLine);
        jobPoints.forEach(function (p, i) {
          if ((p.m.jobs || 0) <= 0) return;
          var jd = document.createElementNS(svgNS, 'circle');
          jd.setAttribute('class', 'aed-chart-dot aed-chart-dot--jobs');
          jd.setAttribute('cx', p.x); jd.setAttribute('cy', p.y);
          jd.setAttribute('r', 3);
          jd.style.animationDelay = (1000 + i * 50) + 'ms';
          svg.appendChild(jd);
        });
      }

      // Vertical hover guideline + active dot
      var guide = document.createElementNS(svgNS, 'line');
      guide.setAttribute('class', 'aed-chart-guide');
      guide.setAttribute('y1', padT); guide.setAttribute('y2', padT + chartH);
      svg.appendChild(guide);

      // Dots
      var dots = points.map(function (p, i) {
        var dot = document.createElementNS(svgNS, 'circle');
        dot.setAttribute('class', 'aed-chart-dot' + (ptTotal(p.m) === 0 ? ' is-empty' : ''));
        dot.setAttribute('cx', p.x); dot.setAttribute('cy', p.y);
        dot.setAttribute('r', 4);
        dot.style.animationDelay = (900 + i * 50) + 'ms';
        svg.appendChild(dot);
        return dot;
      });

      // X-axis labels - thin them so they never overlap. Anchor the spacing to
      // the LAST point (today) and walk LEFT, so the most recent date is always
      // shown and is never crowded by a separately-forced "last" neighbour
      // (the old bug: e.g. 17 and 18 Jun landing on top of each other on 30D).
      // Also show fewer labels on narrow screens where each slot is tiny.
      var maxLabels = W < 420 ? 5 : (W < 640 ? 6 : 8);
      var skip = Math.max(1, Math.ceil(n / maxLabels));
      points.forEach(function (p, i) {
        var xLbl = document.createElementNS(svgNS, 'text');
        var isCurrent = p.m.bucket === todayKey || p.m.bucket === nowMonthKey;
        xLbl.setAttribute('class', 'aed-chart-x-label' + (isCurrent ? ' is-current' : ''));
        xLbl.setAttribute('x', p.x);
        xLbl.setAttribute('y', H - 10);
        // Keep the first / last labels from spilling past the plot edges.
        xLbl.setAttribute('text-anchor', i === 0 ? 'start' : (i === n - 1 ? 'end' : 'middle'));
        if ((n - 1 - i) % skip === 0) {
          xLbl.textContent = p.m.label;
        } else {
          xLbl.style.opacity = 0;
        }
        svg.appendChild(xLbl);
      });

      // Invisible mouse-tracking rect: snap to nearest point on mousemove
      var hover = document.createElementNS(svgNS, 'rect');
      hover.setAttribute('class', 'aed-chart-hover');
      hover.setAttribute('x', padL); hover.setAttribute('y', padT);
      hover.setAttribute('width', chartW); hover.setAttribute('height', chartH);
      hover.setAttribute('fill', 'transparent');
      hover.style.cursor = 'crosshair';
      svg.appendChild(hover);

      function nearestPoint(svgX) {
        var nearest = points[0], best = Infinity;
        for (var i = 0; i < points.length; i++) {
          var d = Math.abs(points[i].x - svgX);
          if (d < best) { best = d; nearest = points[i]; }
        }
        return nearest;
      }

      // Use the hover rect's OWN screen bounding box for mapping. It sits
       // exactly on the chart drawing area (padL..padL+chartW horizontally),
       // so we don't have to compensate for preserveAspectRatio letterboxing
       // around the SVG. This was the source of the off-by-one snap that
       // highlighted the neighbouring point under the cursor.
      // Activate the point nearest a screen-X: highlight its dot, draw the
      // guideline, show the tooltip. Shared by mouse (hover) and touch (tap +
      // horizontal scrub), so the chart is fully readable on phones.
      function activateAt(clientX) {
        var hRect = hover.getBoundingClientRect();
        if (!hRect.width) return;
        var relX = (clientX - hRect.left) / hRect.width; // 0..1 across chart area
        if (relX < 0) relX = 0; else if (relX > 1) relX = 1;
        var svgX = padL + relX * chartW;
        var p = nearestPoint(svgX);
        guide.setAttribute('x1', p.x); guide.setAttribute('x2', p.x);
        guide.classList.add('is-visible');
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', points[idx] === p); });
        showTooltip(svg, p, currency, dots[points.indexOf(p)]);
      }
      function deactivate() {
        guide.classList.remove('is-visible');
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        hideTooltip();
      }
      hover.addEventListener('mousemove', function (e) { activateAt(e.clientX); });
      hover.addEventListener('mouseleave', deactivate);

      // Touch: tap a point to read its value; drag horizontally to scrub the
      // timeline. A vertical drag is left alone so the page still scrolls when
      // the finger starts on the chart. The tooltip auto-dismisses after lift.
      var tStartX = 0, tStartY = 0, scrubbing = false, dismissT = 0;
      svg.addEventListener('touchstart', function (e) {
        var t = e.touches && e.touches[0]; if (!t) return;
        clearTimeout(dismissT);
        tStartX = t.clientX; tStartY = t.clientY; scrubbing = false;
        activateAt(t.clientX);
      }, { passive: true });
      svg.addEventListener('touchmove', function (e) {
        var t = e.touches && e.touches[0]; if (!t) return;
        var dx = Math.abs(t.clientX - tStartX), dy = Math.abs(t.clientY - tStartY);
        if (!scrubbing && dx > dy && dx > 6) scrubbing = true; // horizontal intent
        if (scrubbing) { activateAt(t.clientX); if (e.cancelable) e.preventDefault(); }
        else if (dy > dx && dy > 8) deactivate(); // vertical -> let the page scroll
      }, { passive: false });
      svg.addEventListener('touchend', function () { dismissT = setTimeout(deactivate, 2200); }, { passive: true });

      els.chart.appendChild(svg);
      // Mark the card as rendered so subsequent renders skip entry animations
      // (the CSS [data-rendered="1"] override neutralises them).
      if (!alreadyRendered) {
        // Defer to next frame so the FIRST render gets to play its animations.
        requestAnimationFrame(function () {
          els.chartCard.setAttribute('data-rendered', '1');
        });
      }

      // Legend. When there's custom-service income we show a small colour key
      // (Total vs Custom service) on the left; otherwise just the period total.
      var total = series.reduce(function (s, m) { return s + ptTotal(m); }, 0);
      var jobsTotal = series.reduce(function (s, m) { return s + (m.jobs || 0); }, 0);
      var bestPoint = series.reduce(function (best, m) { return ptTotal(m) > ptTotal(best) ? m : best; }, series[0]);
      els.chartLegend.innerHTML = '';
      var leftSpan = document.createElement('span');
      if (hasJobs) {
        leftSpan.className = 'aed-chart-keys';
        leftSpan.innerHTML =
          '<span class="aed-chart-key"><span class="aed-chart-key-dot aed-chart-key-dot--total"></span>Total <strong>' + fmtMoney(total, currency) + '</strong></span>'
          + '<span class="aed-chart-key"><span class="aed-chart-key-dot aed-chart-key-dot--jobs"></span>Custom service <strong>' + fmtMoney(jobsTotal, currency) + '</strong></span>';
      } else {
        leftSpan.innerHTML = 'Period total: <strong>' + fmtMoney(total, currency) + '</strong>';
      }
      var rightSpan = document.createElement('span');
      if (ptTotal(bestPoint) > 0) {
        rightSpan.innerHTML = 'Best: <strong>' + bestPoint.label + ' (' + fmtMoney(ptTotal(bestPoint), currency) + ')</strong>';
      } else {
        rightSpan.innerHTML = '<span style="opacity:.7">No sales in this range</span>';
      }
      els.chartLegend.appendChild(leftSpan);
      els.chartLegend.appendChild(rightSpan);

      // Stash chart dimensions so the tooltip positioner can map SVG coords
      // back to pixels accurately (matches W/H computed above, not the
      // hardcoded 800/220 we used to pass in).
      els.chart._chartW = W;
      els.chart._chartH = H;
    }

    var tooltip = null;
    function ensureTooltip() {
      if (tooltip) return tooltip;
      tooltip = document.createElement('div');
      tooltip.className = 'aed-chart-tooltip';
      els.chart.appendChild(tooltip);
      return tooltip;
    }
    function showTooltip(svg, point, currency, dotEl) {
      var tt = ensureTooltip();
      var m = point.m;
      var prod = m.earned || 0;
      var jb = m.jobs || 0;
      var tot = prod + jb;
      var html = '<div class="aed-chart-tooltip-title">' + fmtMoney(tot, currency) + '</div>'
        + '<div class="aed-chart-tooltip-sub">' + m.label + ' · ' + m.sales + ' ' + (m.sales === 1 ? 'sale' : 'sales') + '</div>';
      // When custom-service income exists in the period, break the total down
      // so it's clear how much came from products vs custom service.
      if (jb > 0) {
        html += '<div class="aed-chart-tooltip-row"><span class="aed-chart-key-dot aed-chart-key-dot--total"></span>Products <strong>' + fmtMoney(prod, currency) + '</strong></div>'
          + '<div class="aed-chart-tooltip-row"><span class="aed-chart-key-dot aed-chart-key-dot--jobs"></span>Custom service <strong>' + fmtMoney(jb, currency) + '</strong></div>';
      }
      tt.innerHTML = html;
      // Anchor the tooltip on the dot's ACTUAL rendered position rather than
      // mapping SVG-space coords through viewBox arithmetic. The dot is
      // already in screen pixels, so this stays accurate under any container
      // size, aspect-ratio letterboxing, or zoom.
      var parentRect = els.chart.getBoundingClientRect();
      var anchorX, anchorY;
      if (dotEl) {
        var dRect = dotEl.getBoundingClientRect();
        anchorX = dRect.left + dRect.width / 2;
        anchorY = dRect.top + dRect.height / 2;
      } else {
        var sRect = svg.getBoundingClientRect();
        var W = els.chart._chartW || 800;
        var H = els.chart._chartH || 240;
        anchorX = sRect.left + (point.x / W) * sRect.width;
        anchorY = sRect.top + (point.y / H) * sRect.height;
      }
      tt.style.left = (anchorX - parentRect.left) + 'px';
      tt.style.top = (anchorY - parentRect.top) + 'px';
      tt.classList.add('is-visible');
    }
    function hideTooltip() {
      if (tooltip) tooltip.classList.remove('is-visible');
    }

    function renderPayouts(items, currency) {
      if (!items || !items.length) {
        els.payouts.innerHTML = '';
        setCardEmpty(els.payoutsCard, true);
        var stalePager = els.payoutsCard.querySelector('.aed-pager');
        if (stalePager) stalePager.remove();
        return;
      }
      setCardEmpty(els.payoutsCard, false);
      paginate(els.payoutsCard, els.payouts, items, function (slice) {
        slice.forEach(function (p) {
          var row = el('div', { className: 'aed-row' });
          var left = el('div', { className: 'aed-row-left' });
          var title = el('div');
          title.appendChild(el('span', { className: 'aed-row-title', text: fmtMoney(p.amount, p.currency || currency) }));
          var statusClass = p.status === 'paid' ? 'aed-badge--paid' : 'aed-badge--pending';
          var b = el('span', { className: 'aed-badge ' + statusClass, text: p.status });
          b.style.marginLeft = '8px';
          title.appendChild(b);
          left.appendChild(title);
          var sub = fmtDate(p.periodStart) + ' – ' + fmtDate(p.periodEnd);
          if (p.method) sub += ' · ' + p.method;
          if (p.reference) sub += ' · ' + p.reference;
          if (p.paidAt) sub += ' · paid ' + fmtDate(p.paidAt);
          left.appendChild(el('span', { className: 'aed-row-sub', text: sub }));
          row.appendChild(left);
          els.payouts.appendChild(row);
        });
      });
    }

    // Custom-service (Jobs) income list. Only rendered when there are completed
    // + client-paid custom orders. Each row = one order's payout, with a
    // "settled" / "in balance" badge mirroring how it folds into Earnings.
    function renderJobs(jobs, currency) {
      if (!els.jobsCard) return;
      var summary = jobs || { count: 0, items: [], earnedTotal: 0, owed: 0 };
      var items = summary.items || [];
      if (!summary.count || !items.length) {
        els.jobsCard.hidden = true;
        setCardEmpty(els.jobsCard, true);
        var stalePager = els.jobsCard.querySelector('.aed-pager');
        if (stalePager) stalePager.remove();
        return;
      }
      els.jobsCard.hidden = false;
      setCardEmpty(els.jobsCard, false);

      if (els.jobsTotal) {
        var cur = summary.currency || currency;
        var bits = [fmtMoney(summary.earnedTotal, cur) + ' earned'];
        if ((summary.owed || 0) > 0) bits.push(fmtMoney(summary.owed, cur) + ' in balance');
        els.jobsTotal.textContent = bits.join(' · ');
      }

      paginate(els.jobsCard, els.jobs, items, function (slice) {
        slice.forEach(function (j) {
          var cur = j.currency || currency;
          var row = el('div', { className: 'aed-row' });
          var left = el('div', { className: 'aed-row-left' });
          var title = el('div');
          title.appendChild(el('span', { className: 'aed-row-title', text: j.title || 'Custom order' }));
          var badge = j.settled
            ? el('span', { className: 'aed-badge aed-badge--paid', text: 'settled' })
            : el('span', { className: 'aed-badge aed-badge--pending', text: 'in balance' });
          badge.style.marginLeft = '8px';
          title.appendChild(badge);
          left.appendChild(title);
          var sub = [];
          if (j.orderNumber) sub.push('#' + j.orderNumber);
          sub.push(fmtDate(j.completedAt || j.createdAt));
          sub.push('Custom service');
          left.appendChild(el('span', { className: 'aed-row-sub', text: sub.join(' · ') }));
          var right = el('div', { className: 'aed-row-right' });
          right.appendChild(el('span', { className: 'aed-row-amount', text: fmtMoney(j.amount, cur) }));
          row.appendChild(left);
          row.appendChild(right);
          els.jobs.appendChild(row);
        });
      });
    }

    // --- Reporting tool: Day / Month / Year granularity + a CUSTOM styled
    //     calendar popover (no basic native input) + a Download CSV link that
    //     points at the income export for the exact selected window. ---
    var MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var MONTHS_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var WEEKDAYS = ['Mo','Tu','We','Th','Fr','Sa','Su'];

    function pad2(n) { return String(n).padStart(2, '0'); }

    // sel holds the chosen period; view holds what the grid is currently
    // browsing (month for day-picker, year for month-picker, decade for year).
    var reportState = { gran: 'month', built: false, sel: null, viewY: 0, viewM: 0, open: false };

    function todayParts() { var t = new Date(); return { y: t.getFullYear(), m: t.getMonth(), d: t.getDate() }; }

    // Default selection per granularity = the current day / month / year.
    function defaultSel() {
      var t = todayParts();
      if (reportState.gran === 'day') return { y: t.y, m: t.m, d: t.d };
      if (reportState.gran === 'month') return { y: t.y, m: t.m };
      return { y: t.y };
    }

    // [from, to] YYYY-MM-DD window for the current selection.
    function reportRange() {
      var s = reportState.sel;
      if (!s) return null;
      if (reportState.gran === 'day') {
        var ds = s.y + '-' + pad2(s.m + 1) + '-' + pad2(s.d);
        return { from: ds, to: ds };
      }
      if (reportState.gran === 'month') {
        var last = new Date(s.y, s.m + 1, 0).getDate();
        return { from: s.y + '-' + pad2(s.m + 1) + '-01', to: s.y + '-' + pad2(s.m + 1) + '-' + pad2(last) };
      }
      return { from: s.y + '-01-01', to: s.y + '-12-31' };
    }

    function selLabel() {
      var s = reportState.sel;
      if (!s) return 'Pick a period';
      if (reportState.gran === 'day') return s.d + ' ' + MONTHS_SHORT[s.m] + ' ' + s.y;
      if (reportState.gran === 'month') return MONTHS_FULL[s.m] + ' ' + s.y;
      return String(s.y);
    }

    function updateReportDownload() {
      if (!els.reportDownload) return;
      var r = reportRange();
      var base = '/apps/proxy/api/storefront/authors/export.csv?type=income';
      els.reportDownload.href = r
        ? base + '&from=' + encodeURIComponent(r.from) + '&to=' + encodeURIComponent(r.to)
        : base;
    }

    var calTrigger, calLabel, calPop;

    function closeCal() {
      reportState.open = false;
      if (calPop) calPop.classList.remove('is-open');
      if (calTrigger) calTrigger.setAttribute('aria-expanded', 'false');
    }
    function openCal() {
      reportState.open = true;
      // Browse from the current selection.
      var s = reportState.sel || defaultSel();
      reportState.viewY = s.y;
      reportState.viewM = (s.m != null ? s.m : 0);
      renderCalGrid();
      if (calPop) calPop.classList.add('is-open');
      if (calTrigger) calTrigger.setAttribute('aria-expanded', 'true');
    }

    function calHeader(title, onPrev, onNext, prevDisabled, nextDisabled) {
      var head = el('div', { className: 'aed-cal-head' });
      var prev = el('button', { className: 'aed-cal-nav', attrs: { type: 'button', 'aria-label': 'Previous' } });
      prev.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      if (prevDisabled) prev.disabled = true; else prev.addEventListener('click', function (e) { e.stopPropagation(); onPrev(); });
      var t = el('span', { className: 'aed-cal-title', text: title });
      var next = el('button', { className: 'aed-cal-nav', attrs: { type: 'button', 'aria-label': 'Next' } });
      next.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      if (nextDisabled) next.disabled = true; else next.addEventListener('click', function (e) { e.stopPropagation(); onNext(); });
      head.appendChild(prev); head.appendChild(t); head.appendChild(next);
      return head;
    }

    function pickSel(newSel) {
      reportState.sel = newSel;
      if (calLabel) calLabel.textContent = selLabel();
      updateReportDownload();
      closeCal();
    }

    function renderCalGrid() {
      if (!calPop) return;
      calPop.innerHTML = '';
      var t = todayParts();
      var s = reportState.sel || {};

      if (reportState.gran === 'day') {
        var vy = reportState.viewY, vm = reportState.viewM;
        var atCurrentMonth = (vy > t.y) || (vy === t.y && vm >= t.m);
        calPop.appendChild(calHeader(MONTHS_FULL[vm] + ' ' + vy,
          function () { reportState.viewM--; if (reportState.viewM < 0) { reportState.viewM = 11; reportState.viewY--; } renderCalGrid(); },
          function () { reportState.viewM++; if (reportState.viewM > 11) { reportState.viewM = 0; reportState.viewY++; } renderCalGrid(); },
          false, atCurrentMonth));
        var dow = el('div', { className: 'aed-cal-dow' });
        WEEKDAYS.forEach(function (w) { dow.appendChild(el('span', { text: w })); });
        calPop.appendChild(dow);
        var grid = el('div', { className: 'aed-cal-grid aed-cal-grid--days' });
        // JS getDay(): 0=Sun..6=Sat. We want Monday-first, so shift.
        var firstDow = (new Date(vy, vm, 1).getDay() + 6) % 7;
        var daysIn = new Date(vy, vm + 1, 0).getDate();
        for (var b = 0; b < firstDow; b++) grid.appendChild(el('span', { className: 'aed-cal-cell is-blank' }));
        for (var dd = 1; dd <= daysIn; dd++) {
          var future = (vy > t.y) || (vy === t.y && (vm > t.m || (vm === t.m && dd > t.d)));
          var isSel = s.y === vy && s.m === vm && s.d === dd;
          var cell = el('button', { className: 'aed-cal-cell' + (isSel ? ' is-selected' : '') + (future ? ' is-disabled' : ''), text: String(dd), attrs: { type: 'button' } });
          if (future) { cell.disabled = true; }
          else { (function (day) { cell.addEventListener('click', function (e) { e.stopPropagation(); pickSel({ y: vy, m: vm, d: day }); }); })(dd); }
          grid.appendChild(cell);
        }
        calPop.appendChild(grid);

      } else if (reportState.gran === 'month') {
        var vY = reportState.viewY;
        calPop.appendChild(calHeader(String(vY),
          function () { reportState.viewY--; renderCalGrid(); },
          function () { reportState.viewY++; renderCalGrid(); },
          false, vY >= t.y));
        var mgrid = el('div', { className: 'aed-cal-grid aed-cal-grid--months' });
        for (var mi = 0; mi < 12; mi++) {
          var futureM = (vY > t.y) || (vY === t.y && mi > t.m);
          var selM = s.y === vY && s.m === mi;
          var mcell = el('button', { className: 'aed-cal-cell aed-cal-cell--month' + (selM ? ' is-selected' : '') + (futureM ? ' is-disabled' : ''), text: MONTHS_SHORT[mi], attrs: { type: 'button' } });
          if (futureM) { mcell.disabled = true; }
          else { (function (mm) { mcell.addEventListener('click', function (e) { e.stopPropagation(); pickSel({ y: vY, m: mm }); }); })(mi); }
          mgrid.appendChild(mcell);
        }
        calPop.appendChild(mgrid);

      } else {
        // Year: a 12-year window ending at the view anchor.
        var anchor = reportState.viewY || t.y;
        var endY = Math.min(anchor, t.y);
        var startY = endY - 11;
        calPop.appendChild(calHeader(startY + ' – ' + endY,
          function () { reportState.viewY = anchor - 12; renderCalGrid(); },
          function () { reportState.viewY = Math.min(anchor + 12, t.y); renderCalGrid(); },
          false, endY >= t.y));
        var ygrid = el('div', { className: 'aed-cal-grid aed-cal-grid--months' });
        for (var yy = startY; yy <= endY; yy++) {
          var selY = s.y === yy;
          var ycell = el('button', { className: 'aed-cal-cell aed-cal-cell--month' + (selY ? ' is-selected' : ''), text: String(yy), attrs: { type: 'button' } });
          (function (yr) { ycell.addEventListener('click', function (e) { e.stopPropagation(); pickSel({ y: yr }); }); })(yy);
          ygrid.appendChild(ycell);
        }
        calPop.appendChild(ygrid);
      }
    }

    function buildReportPicker() {
      if (!els.reportPicker) return;
      els.reportPicker.innerHTML = '';
      reportState.sel = defaultSel();

      var wrap = el('div', { className: 'aed-cal' });
      calTrigger = el('button', { className: 'aed-cal-trigger', attrs: { type: 'button', 'aria-haspopup': 'dialog', 'aria-expanded': 'false' } });
      calTrigger.innerHTML = '<svg class="aed-cal-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>';
      calLabel = el('span', { className: 'aed-cal-label', text: selLabel() });
      calTrigger.appendChild(calLabel);
      calTrigger.appendChild(svgEl('<svg class="aed-cal-caret" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>'));
      calTrigger.addEventListener('click', function (e) { e.stopPropagation(); if (reportState.open) closeCal(); else openCal(); });

      calPop = el('div', { className: 'aed-cal-pop', attrs: { role: 'dialog' } });

      wrap.appendChild(calTrigger);
      wrap.appendChild(calPop);
      els.reportPicker.appendChild(wrap);
      updateReportDownload();
    }

    // Close the calendar on any outside click (registered once).
    document.addEventListener('click', function (e) {
      if (reportState.open && els.reportPicker && !els.reportPicker.contains(e.target)) closeCal();
    });

    // Close any open stat-detail popover when clicking/tapping outside its tile.
    document.addEventListener('click', function (e) {
      inner.querySelectorAll('.aed-stat.is-open').forEach(function (o) {
        if (!o.contains(e.target)) o.classList.remove('is-open');
      });
    });

    function buildReportControls() {
      if (reportState.built || !els.reportGran) return;
      buildPills(els.reportGran, [['day', 'Day'], ['month', 'Month'], ['year', 'Year']],
        function () { return reportState.gran; },
        function (v) { reportState.gran = v; closeCal(); buildReportPicker(); });
      reportState.built = true;
      buildReportPicker();
    }

    function makeMockData(parsed) {
      parsed = parsed || { unit: 'd', size: 30 };
      var m = parsed.size;
      var unit = parsed.unit;
      var monthLabels = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var now = new Date();
      var series = [];
      for (var i = m - 1; i >= 0; i--) {
        var d, key, label;
        if (unit === 'y') {
          d = new Date(now.getFullYear() - i, 0, 1);
          key = d.getFullYear() + '-01-01';
          label = String(d.getFullYear());
        } else if (unit === 'm') {
          d = new Date(now.getFullYear(), now.getMonth() - i, 1);
          key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-01';
          label = monthLabels[d.getMonth()];
        } else {
          d = new Date(now);
          d.setDate(d.getDate() - i);
          d.setHours(0, 0, 0, 0);
          key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
          label = d.getDate() + ' ' + monthLabels[d.getMonth()];
        }
        // Smooth wave + soft upward trend so the curve has shape.
        var wave = Math.sin((m - i) * 0.5) * 90 + 110 + (m - i) * 4;
        // Custom-service contribution: a smaller, phase-shifted wave so the
        // second (gold) line reads as a distinct, lower band in the preview.
        var jobsWave = Math.max(0, Math.sin((m - i) * 0.4 + 1) * 40 + 45);
        series.push({
          bucket: key,
          label: label,
          earned: Math.round(wave),
          jobs: Math.round(jobsWave),
          sales: Math.max(1, Math.round(wave / 30)),
        });
      }
      var total = series.reduce(function (s, x) { return s + x.earned; }, 0);
      // Demo split: ~72% products, ~28% custom service, so the donut + jobs
      // card + sub-stats all have something to show in the theme editor.
      var jobsEarned = Math.round(total * 0.28);
      var productsEarned = total - jobsEarned;
      var balance = {
        currency: 'USD',
        totalEarned: total,
        totalPaid: Math.round(total * 0.55),
        awaitingPayout: 0,
        pendingBalance: Math.round(total * 0.45),
        earnedSalesCount: series.reduce(function (s, x) { return s + x.sales; }, 0),
        refundedSalesCount: 2,
        payoutsCount: 3,
        productsEarned: productsEarned,
        jobsEarned: jobsEarned,
        jobsOwed: Math.round(jobsEarned * 0.4),
        jobsCount: 3,
        totalDiscounts: Math.round(total * 0.12),
      };
      var jobs = {
        currency: 'USD',
        earnedTotal: jobsEarned,
        paidTotal: Math.round(jobsEarned * 0.6),
        paidViaOrders: Math.round(jobsEarned * 0.6),
        owed: Math.round(jobsEarned * 0.4),
        count: 3,
        items: [
          { payoutId: 'j1', orderId: 'o1', orderNumber: '1043', title: 'Brand identity pack', amount: Math.round(jobsEarned * 0.45), currency: 'USD', settled: false, createdAt: new Date(now - 86400000 * 5).toISOString(), completedAt: new Date(now - 86400000 * 4).toISOString() },
          { payoutId: 'j2', orderId: 'o2', orderNumber: '1021', title: 'Custom packaging mockups', amount: Math.round(jobsEarned * 0.35), currency: 'USD', settled: true, createdAt: new Date(now - 86400000 * 22).toISOString(), completedAt: new Date(now - 86400000 * 20).toISOString() },
          { payoutId: 'j3', orderId: 'o3', orderNumber: '0998', title: 'Label redesign', amount: jobsEarned - Math.round(jobsEarned * 0.45) - Math.round(jobsEarned * 0.35), currency: 'USD', settled: true, createdAt: new Date(now - 86400000 * 40).toISOString(), completedAt: new Date(now - 86400000 * 38).toISOString() },
        ],
      };
      var products = [
        { productGid: 'gid://demo/1', productTitle: 'Paper Box Mockup – High Angle', productImageUrl: null, productHandle: null, salesCount: 14, unitsSold: 16, totalGross: 1280, totalAuthorEarning: 896, currency: 'USD' },
        { productGid: 'gid://demo/2', productTitle: 'Plastic Jar Mockup – Angled Floating View', productImageUrl: null, productHandle: null, salesCount: 9, unitsSold: 11, totalGross: 810, totalAuthorEarning: 567, currency: 'USD' },
        { productGid: 'gid://demo/3', productTitle: 'Coffee Cup Mockup – Front View', productImageUrl: null, productHandle: null, salesCount: 6, unitsSold: 7, totalGross: 540, totalAuthorEarning: 378, currency: 'USD' },
        { productGid: 'gid://demo/4', productTitle: 'Free Paper Cup Mockup – Front View', productImageUrl: null, productHandle: null, salesCount: 312, unitsSold: 340, freebieDownloads: 96, totalGross: 0, totalAuthorEarning: 0, currency: 'USD' },
      ];
      var sales = [
        { id: 'd1', shopifyOrderName: '#1217', productGid: 'gid://demo/1', productTitle: 'Paper Box Mockup – High Angle', productImageUrl: null, productHandle: null, quantity: 1, grossAmount: 95, revenueSharePct: 70, authorEarning: 66.5, currency: 'USD', status: 'earned', createdAt: new Date(now - 86400000 * 3).toISOString(), refundedAt: null },
        { id: 'd2', shopifyOrderName: '#1212', productGid: 'gid://demo/2', productTitle: 'Plastic Jar Mockup – Angled Floating View', productImageUrl: null, productHandle: null, quantity: 1, grossAmount: 85, revenueSharePct: 70, authorEarning: 59.5, currency: 'USD', status: 'earned', createdAt: new Date(now - 86400000 * 8).toISOString(), refundedAt: null },
        { id: 'd3', shopifyOrderName: '#1205', productGid: 'gid://demo/3', productTitle: 'Coffee Cup Mockup – Front View', productImageUrl: null, productHandle: null, quantity: 1, grossAmount: 75, revenueSharePct: 70, authorEarning: 52.5, currency: 'USD', status: 'refunded', createdAt: new Date(now - 86400000 * 16).toISOString(), refundedAt: new Date(now - 86400000 * 14).toISOString() },
        { id: 'd4', shopifyOrderName: '#1199', productGid: 'gid://demo/4', productTitle: 'Free Paper Cup Mockup – Front View', productImageUrl: null, productHandle: null, quantity: 1, grossAmount: 0, revenueSharePct: 70, authorEarning: 0, currency: 'USD', status: 'earned', createdAt: new Date(now - 86400000 * 20).toISOString(), refundedAt: null },
      ];
      var payouts = [
        { id: 'pp1', periodStart: new Date(now.getFullYear(), now.getMonth() - 1, 1).toISOString(), periodEnd: new Date(now.getFullYear(), now.getMonth(), 0).toISOString(), amount: 740, currency: 'USD', status: 'paid', method: 'PayPal', reference: 'PP-A4F2', createdAt: new Date(now - 86400000 * 30).toISOString(), paidAt: new Date(now - 86400000 * 28).toISOString() },
        { id: 'pp2', periodStart: new Date(now.getFullYear(), now.getMonth(), 1).toISOString(), periodEnd: now.toISOString(), amount: 620, currency: 'USD', status: 'pending', method: null, reference: null, createdAt: new Date(now - 86400000 * 2).toISOString(), paidAt: null },
      ];
      return { balance: balance, sales: sales, salesTotal: 18, productEarnings: products, payouts: payouts, series: series, jobs: jobs, freebieDownloads: { total: 128, gated: 84, freeProducts: 44 } };
    }

    function parseRange(r) {
      // '7d' / '30d' / '6m' / '12m' / '5y' -> { unit, size }
      var match = String(r || '30d').match(/^(\d+)([dmy])$/i);
      if (!match) return { unit: 'd', size: 30 };
      return { unit: match[2].toLowerCase(), size: parseInt(match[1], 10) };
    }

    // `seriesOnly=true` skips re-fetching balance/sales/products/payouts and
    // only updates the chart. Used by range-button clicks (7D / 30D / 6M /
    // 12M) so we don't pull the whole dashboard payload just to change the
    // chart timeframe. The initial load passes `false`.
    function load(range, seriesOnly) {
      var parsed = parseRange(range);
      if (isPreview) {
        var d = makeMockData(parsed);
        state.currency = d.balance.currency;
        state.monthly = d.series;
        state.minPayout = 100;
        state.freebieDownloads = d.freebieDownloads;
        state.jobsCount = (d.jobs && d.jobs.count) || 0;
        if (!seriesOnly) {
          renderBalance(d.balance);
          renderProducts(d.productEarnings, d.balance.currency);
          renderJobs(d.jobs, d.balance.currency);
          renderSales(d.sales, d.salesTotal, d.balance.currency);
          renderPayouts(d.payouts, d.balance.currency);
          buildReportControls();
        }
        renderChart(d.series, d.balance.currency);
        if (els.empty) els.empty.hidden = true;
        return Promise.resolve();
      }
      // Granularity param: days / months / years, matching the endpoint.
      var seriesParam = parsed.unit === 'd' ? 'days=' + parsed.size
        : parsed.unit === 'y' ? 'years=' + parsed.size
        : 'months=' + parsed.size;
      var url = '/apps/proxy/api/storefront/authors/earnings?'
        + seriesParam
        + (seriesOnly ? '&seriesOnly=1' : '&salesTake=100');
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { setShopTz(j && j.timeZone); return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          if (!resp.ok) {
            els.meta.textContent = (resp.json && resp.json.error) || 'Failed to load earnings.';
            return;
          }
          var d = resp.json;
          state.monthly = d.series || d.monthly || [];
          if (typeof d.minPayoutAmount === 'number') state.minPayout = d.minPayoutAmount;

          // seriesOnly response carries no balance - just re-draw the chart
          // and bail out. This is the lightweight path for range button
          // clicks: no extra Prisma queries, no DOM thrash on the lists.
          if (seriesOnly) {
            renderChart(state.monthly, state.currency);
            return;
          }

          state.currency = d.balance.currency;
          state.freebieDownloads = d.freebieDownloads;
          state.jobsCount = (d.jobs && d.jobs.count) || 0;
          renderBalance(d.balance);
          renderChart(state.monthly, state.currency);
          renderProducts(d.productEarnings, d.balance.currency);
          renderJobs(d.jobs, d.balance.currency);
          renderSales(d.sales, d.salesTotal, d.balance.currency);
          renderPayouts(d.payouts, d.balance.currency);
          buildReportControls();
          if ((!d.sales || !d.sales.length)
              && (!d.productEarnings || !d.productEarnings.length)
              && (!d.payouts || !d.payouts.length)
              && (!d.jobs || !d.jobs.count)) {
            if (els.empty) els.empty.hidden = false;
          } else {
            if (els.empty) els.empty.hidden = true;
          }
        })
        .catch(function (e) {
          els.meta.textContent = 'Failed to load earnings: ' + e.message;
        });
    }

    // Range buttons = a single shared PERIOD selector. A click re-loads the
    // chart AND every list (sales / products / payouts / jobs) filtered to that
    // period; the account tiles stay global. Reset list pagers to page 1 so the
    // new period starts at the top.
    els.rangeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var range = btn.getAttribute('data-aed-range') || '30d';
        els.rangeButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        [els.productsCard, els.salesCard, els.payoutsCard, els.jobsCard].forEach(function (c) { if (c) c.dataset.page = '1'; });
        load(range, /* seriesOnly */ false);
      });
    });

    load('30d', /* seriesOnly */ false);
  }

  function boot() {
    document.querySelectorAll('.aed-wrapper').forEach(function (root) {
      if (root.dataset.aedInit === '1') return;
      root.dataset.aedInit = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
